/* src/app/rating/header/header.component.scss */
h1.main-title {
  font-size: 2rem;
}
/*# sourceMappingURL=header.component.css.map */
